import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Dropdown from '../Dropdown/Dropdown';
import globalButtonStyles from '../../styles/ButtonGradient.module.css';
import styles from './GameIQModal.module.css';

const GameIQModal = ({ isOpen, onClose, onBegin, sportOptions, getLevelOptions, initialSport }) => {
  const [selectedSport, setSelectedSport] = useState('');
  const [selectedLevel, setSelectedLevel] = useState('');

  const singleSport = sportOptions.length === 1;
  const levelOptions = selectedSport ? getLevelOptions(selectedSport) : [];
  const canBegin = selectedSport && selectedLevel;

  useEffect(() => {
    if (isOpen) {
      const sport = initialSport || (singleSport ? sportOptions[0]?.value : '');
      setSelectedSport(sport || '');
      setSelectedLevel('');
    }
  }, [isOpen, initialSport, singleSport, sportOptions]);

  const handleSportChange = (val) => {
    setSelectedSport(val);
    setSelectedLevel('');
  };

  const handleBegin = () => {
    if (!canBegin) return;
    onBegin(selectedSport, selectedLevel);
    onClose();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={styles.overlay}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className={styles.modal}
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <button className={styles.closeButton} onClick={onClose} aria-label="Close">✕</button>

            <div className={styles.header}>
              <h2 className={styles.title}>Sports IQ Assessment</h2>
              <p className={styles.description}>
                Test your knowledge of sport rules, strategy, and in-game situations.
                Each level features 10 multiple-choice questions. Pass to unlock the next
                level and build your Sports IQ profile over time.
              </p>
            </div>

            <div className={styles.selectors}>
              {singleSport ? (
                <div className={styles.sportDisplay}>
                  <span className={styles.sportDisplayLabel}>Sport</span>
                  <span className={styles.sportDisplayValue}>{sportOptions[0]?.label}</span>
                </div>
              ) : (
                <Dropdown
                  options={sportOptions}
                  value={selectedSport}
                  onChange={handleSportChange}
                  placeholder="Select Sport"
                />
              )}

              <Dropdown
                options={levelOptions}
                value={selectedLevel}
                onChange={setSelectedLevel}
                placeholder="Select Level"
              />
            </div>

            <button
              className={`${globalButtonStyles.button} ${styles.beginButton}`}
              onClick={handleBegin}
              disabled={!canBegin}
            >
              Begin Assessment
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default GameIQModal;
